<template>
    <div class="m-container py-10">
        <div class="m-row" style="justify-content: center;">
            <div class="m-col m-col-12 m-col-md-8">
                <h1 class="titel-h1 font-weight-bold mb-6">Impressum</h1>

                <p class="text-body-1 mb-4">
                    Zu Beachten: moebix.de ist kein Online-Shop und verkauft
                    keine auf diese Webseiten aufgeführten Artikeln.<br />
                    Es können keine Bestellungen entgegengenommen werden, noch
                    Fragen zur Verfügbarkeit oder zu technischen Aspekten
                    beantwortet werden.<br />
                    Bitte wenden Sie sich diesbezüglich bei Fragen direkt an den
                    entsprechenden Online-Shop.<br />
                    Danke für ihre Verständnis<br /><br />
                    moebix.de ist ein neues Produkt der webdelin.com Webdesign
                    &amp; Webentwicklung<br /><br />
                    4 Rue de Heidaecker<br />
                    57510 Puttelange aux Lacs<br />
                    info@moebix.de
                </p>

                <p class="text-body-1 mb-4">
                    Aufgrund des Kleinunternehmerstatus wird gemäß § 19 UStG die
                    MwSt. in der Rechnung nicht ausgewiesen.<br /><br />

                    Alternative Streitbeilegung:<br />
                    Die Europäische Kommission stellt eine Plattform für die
                    außergerichtliche Online-Streitbeilegung (OS-Plattform)
                    bereit, aufrufbar unter
                    <a
                        target="_blank"
                        rel="nofollow"
                        href="https://ec.europa.eu/consumers/odr"
                        >https://ec.europa.eu/odr</a
                    >.<br /><br />

                    Wir sind seit 18.08.2020 Mitglied der Initiative
                    "FairCommerce". Nähere Informationen hierzu finden Sie unter
                    <a
                        target="_blank"
                        rel="nofollow"
                        href="https://www.fair-commerce.de/"
                        >www.fair-commerce.de</a
                    >.
                </p>

                <hr class="m-divider my-6" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: "Impressum | Moebix",
    description:
        "Impressum gemäß § 19 UStG — möbix.de ist kein Online-Shop und verkauft keine Artikel.",
    ogTitle: "Impressum — Moebix.de",
    ogDescription:
        "Impressum gemäß § 19 UStG — möbix.de ist kein Online-Shop und verkauft keine Artikel.",
    ogType: "website",
    ogImage: "/moebix_og_sticker.jpg",
    ogUrl: "https://www.moebix.de/impressum",
});

useHead({
    link: [{ rel: "canonical", href: "https://www.moebix.de/impressum" }],
});
</script>
